import { FormikProps } from 'formik'
import { DocumentoPessoaLabels, DocumentoPessoaType, MaskType } from '_metronic/helpers'
import { FormInput, FormSelect } from 'app/components'
import { useT } from '_metronic/i18n/Metronici18n'
import { OPCOES_DOCUMENTO_ESTRANGEIRO, precisaDocumentoEstrangeiro } from './identificadores'

type IProps<V> = {
  formik: FormikProps<V>
  /** Prefixo dos campos no formik (`funcionario.` ou vazio). */
  prefixo: string
  cpf: string
  cns: string
  documentoEstrangeiroNaLista: boolean
  idPrefix: string
}

/** CPF e CNS independentes; documento estrangeiro só quando nenhum dos dois foi informado. */
export const IdentificadoresPessoaFields = <V,>({
  formik,
  prefixo,
  cpf,
  cns,
  documentoEstrangeiroNaLista,
  idPrefix,
}: IProps<V>) => {
  const { t } = useT()
  const mostrarEstrangeiro = precisaDocumentoEstrangeiro(cpf, cns, documentoEstrangeiroNaLista)

  return (
    <>
      <div className='row mb-3'>
        <div className='col-md-6'>
          <FormInput
            formik={formik}
            name={`${prefixo}cpf`}
            label={DocumentoPessoaLabels[DocumentoPessoaType.Cpf]}
            placeholder='000.000.000-00'
            mask={MaskType.CPF}
          />
        </div>
        <div className='col-md-6'>
          <FormInput
            formik={formik}
            name={`${prefixo}cns`}
            label={DocumentoPessoaLabels[DocumentoPessoaType.Cns]}
            placeholder='000 0000 0000 0000'
            mask={MaskType.CNS}
          />
        </div>
      </div>
      {mostrarEstrangeiro && (
        <div className='row mb-3'>
          <div className='col-md-6'>
            <FormSelect
              formik={formik}
              name={`${prefixo}documentoEstrangeiroTipo`}
              inputId={`${idPrefix}-documentoEstrangeiroTipo`}
              label={t('documento_pessoa.estrangeiro_tipo')}
              options={OPCOES_DOCUMENTO_ESTRANGEIRO}
              isClearable={false}
              isDisabled={formik.isSubmitting}
            />
          </div>
          <div className='col-md-6'>
            <FormInput
              formik={formik}
              name={`${prefixo}documentoEstrangeiroNumero`}
              label={t('documento_pessoa.estrangeiro_numero')}
              infoText={t('documento_pessoa.estrangeiro_info')}
              isRequired
            />
          </div>
        </div>
      )}
    </>
  )
}
